import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";

const Whatsapp = ({ data }) => {
  const [subject, setSubject] = useState("");

  useEffect(() => {
    if (data) {
      setSubject(data);
    }
  }, [data]);

  const whatsappClick = () => {
    window.open(
      `https://wa.me/918108888168?text=Hello%20I%20am%20interested%20in%20${subject}%20Project%20Please%20share%20details!`,
      "_blank"
    );
  };

  return (
    <>
      <div class="fixed-whatsapp-div" onClick={whatsappClick}>
        <FaWhatsapp className="whatsapp-icon" />
      </div>
      <div class="fixed-phone-div">
        <Link to={`tel:+918108888168`}>
          <FiPhoneCall className="whatsapp-icon" />
        </Link>
      </div>
    </>
  );
};

export default Whatsapp;
